import { render, staticRenderFns } from "./smd-checkbox.vue?vue&type=template&id=a1b8c1ce&"
import script from "./smd-checkbox.vue?vue&type=script&lang=js&"
export * from "./smd-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./smd-checkbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports